module.exports = __webpack_public_path__ + "img/check_grey_border.10d9359a.svg";